import { makeStyles } from "@mui/styles";

export default makeStyles(theme => ({
  bottomActionBarContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(5),
  },
  typo: {
    color: theme.palette.text.hint,
  },
  button: {
    boxShadow: theme.customShadows.widget,
    marginLeft: theme.spacing(2.5),    
    textTransform: "none",
    "&:active": {
      boxShadow: theme.customShadows.widgetWide,
    },
  },
}));
